module.exports = __webpack_public_path__ + "img/15.24049a6c.png";